import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTheregisterComponent } from './simple-icons-theregister.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTheregisterComponent ],
    exports:      [ SimpleIconsTheregisterComponent ],
    bootstrap:    []
})
export class SimpleIconsTheregisterModule {}
